export default __webpack_public_path__ + "static/media/about-score_img-layers.1a7ab076.png";